import { Instance } from 'mobx-state-tree';
import { AuthErrorDtoModelBase } from './AuthErrorDtoModel.base';

/* The TypeScript type of an instance of AuthErrorDtoModel */
export interface AuthErrorDtoModelType extends Instance<typeof AuthErrorDtoModel.Type> {}

/* A graphql query fragment builders for AuthErrorDtoModel */
export { selectFromAuthErrorDto, authErrorDtoModelPrimitives, AuthErrorDtoModelSelector } from './AuthErrorDtoModel.base';

/**
 * AuthErrorDtoModel
 */
export const AuthErrorDtoModel = AuthErrorDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
